import React from 'react';
import { BaseBoxProps, Box, TextV2 } from '@withjoy/joykit';
import { StyledItemBox, StyledProductPhoto, StyledProductPhotoBox, StyledGridBox, StyledTitleText, styles } from './ItemBase.styles';
import { addRendition } from '@shared/utils/photoRendition';
import { CookedProduct } from '@apps/registry/common/selectors/ProductListSelector';

export type ItemBaseVariant = 'normal' | 'transparent';

type ItemBaseProps = Readonly<{
  product: Partial<CookedProduct>;
  siteName?: string | null;
  variant?: ItemBaseVariant;
  registryItemId?: string;
}> &
  BaseBoxProps;

export const ItemBase: React.FC<ItemBaseProps> = ({ product, siteName, variant, registryItemId, __css, children }) => {
  return (
    <StyledItemBox variant={variant}>
      <Box>
        <StyledGridBox
          display="grid"
          gridTemplateColumns="0.5fr 1fr 0"
          gridGap="12px"
          {...__css}
        >
          <StyledProductPhotoBox>
            <StyledProductPhoto backgroundImage={addRendition({ url: product.image, renditionSize: 'medium', isProduct: true })} />
          </StyledProductPhotoBox>
          <Box>
            <Box>
              {siteName && (
                <TextV2
                  typographyVariant="label2"
                  color="mono12"
                >
                  {siteName}
                </TextV2>
              )}
              <StyledTitleText
                typographyVariant="hed1"
                component="p"
                __css={styles.titleText}
              >
                {product.title}
              </StyledTitleText>
            </Box>
            {children}
          </Box>
        </StyledGridBox>
      </Box>
    </StyledItemBox>
  );
};
